import React, { useEffect, useState } from "react";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.min.css";

const CategoriesPage = () => {
  const [categories, setCategories] = useState([]);
  const [newCategory, setNewCategory] = useState("");
  const [editingCategory, setEditingCategory] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Fetch categories from the backend
  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = () => {
    setLoading(true);
    axios
      .get("https://agpipefitting.org.et/api/categories")
      .then((response) => {
        setCategories(response.data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching categories:", error);
        setError("Failed to load categories. Please try again later.");
        setLoading(false);
      });
  };

  // Add new category
  const handleAddCategory = (e) => {
    e.preventDefault();
    if (newCategory.trim() === "") {
      setError("Category name cannot be empty.");
      return;
    }
    setError("");
    setLoading(true);
    axios
      .post("https://agpipefitting.org.et/api/categories", { name: newCategory })
      .then((response) => {
        setCategories([...categories, response.data]);
        setNewCategory("");
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error adding category:", error);
        setError("Failed to add category. Please try again later.");
        setLoading(false);
      });
  };

  // Update category
  const handleUpdateCategory = (e) => {
    e.preventDefault();
    if (editingCategory.name.trim() === "") {
      setError("Category name cannot be empty.");
      return;
    }
    setError("");
    setLoading(true);
    axios
      .put(`https://agpipefitting.org.et/api/categories/${editingCategory.id}`, {
        name: editingCategory.name,
      })
      .then((response) => {
        setCategories(
          categories.map((category) =>
            category.id === editingCategory.id ? response.data : category
          )
        );
        setEditingCategory(null);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error updating category:", error);
        setError("Failed to update category. Please try again later.");
        setLoading(false);
      });
  };

  // Delete category
  const handleDeleteCategory = (id) => {
    if (!window.confirm("Are you sure you want to delete this category?")) {
      return;
    }
    setLoading(true);
    axios
      .delete(`https://agpipefitting.org.et/api/categories/${id}`)
      .then(() => {
        setCategories(categories.filter((category) => category.id !== id));
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error deleting category:", error);
        setError("Failed to delete category. Please try again later.");
        setLoading(false);
      });
  };

  return (
    <div className="container my-5">
      <h1 className="text-center text-primary fw-bold mb-4">Manage Categories</h1>

      {/* Error Message */}
      {error && <div className="alert alert-danger">{error}</div>}

      {/* Add or Edit Category */}
      <form
        onSubmit={
          editingCategory ? handleUpdateCategory : handleAddCategory
        }
        className="mb-4"
      >
        <div className="input-group">
          <input
            type="text"
            className="form-control"
            placeholder="Enter Category Name"
            value={editingCategory ? editingCategory.name : newCategory}
            onChange={(e) =>
              editingCategory
                ? setEditingCategory({ ...editingCategory, name: e.target.value })
                : setNewCategory(e.target.value)
            }
          />
          <button
            type="submit"
            className="btn btn-success"
            disabled={loading}
          >
            {loading
              ? "Processing..."
              : editingCategory
              ? "Update"
              : "Add"}
          </button>
          {editingCategory && (
            <button
              type="button"
              className="btn btn-secondary ms-2"
              onClick={() => setEditingCategory(null)}
            >
              Cancel
            </button>
          )}
        </div>
      </form>

      {/* List Categories */}
      {loading && categories.length === 0 ? (
        <div className="text-center text-muted">Loading categories...</div>
      ) : (
        <ul className="list-group">
          {categories.map((category) => (
            <li
              key={category.id}
              className="list-group-item d-flex justify-content-between align-items-center"
            >
              {editingCategory && editingCategory.id === category.id ? (
                <input
                  type="text"
                  className="form-control"
                  value={editingCategory.name}
                  onChange={(e) =>
                    setEditingCategory({ ...editingCategory, name: e.target.value })
                  }
                />
              ) : (
                <span>{category.name}</span>
              )}
              <div>
                <button
                  className="btn btn-primary btn-sm me-2"
                  onClick={() => setEditingCategory(category)}
                  disabled={editingCategory && editingCategory.id === category.id}
                >
                  Edit
                </button>
                <button
                  className="btn btn-danger btn-sm"
                  onClick={() => handleDeleteCategory(category.id)}
                  disabled={loading}
                >
                  Delete
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CategoriesPage;
